import { Alert } from '@mui/material';
import { useDeleteMenusMutation } from 'api/ordering-service/ordering-service';
import ConfirmationDrawer from 'components/drawers/confirmation-drawer/confirmation-drawer.component';
import { useBulkEditDataGridContext } from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

type MenusDeleteDrawerProps = {
  open: boolean;
  close: () => void;
};

const MenusDeleteDrawer = ({ open, close }: MenusDeleteDrawerProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteMenus] = useDeleteMenusMutation();
  const { selectedRowIds } = useBulkEditDataGridContext();

  const handleDeleteMenus = async () => {
    try {
      await deleteMenus({ catalogIds: selectedRowIds }).unwrap();
      enqueueSnackbar(t('MenusDataGrid.additionalMenus.delete.alertMessage'), {
        severity: 'success',
      });
    } catch (_e) {}
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      submitButtonLabel={t('drawer.menusDeleteDrawer.submitButtonLabel')}
      onValid={handleDeleteMenus}
      cancel={close}
      color="error"
    >
      <Alert severity="info">
        {t('drawer.menusDeleteDrawer.alertMessage', {
          count: selectedRowIds.length,
        })}
      </Alert>
    </ConfirmationDrawer>
  );
};

export default MenusDeleteDrawer;
